import React from 'react';
import { connect } from 'react-redux';
import { IconButton } from 'react-toolbox/lib/button';
import Tag from '~/components/Tag';
import styleDialog from '~/style/dialog.scss';


class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  renderContent() {
    return (<form onSubmit={e => { e.preventDefault(); this.submit(); }}>
      <p>Pick a Recipe</p>
      <div style={{ overflow: 'auto', maxWidth: '50vw', maxHeight: '50vh' }}>
        {Object.keys(this.props.items).map(id => (<div key={id}>
          <Tag
            id={id}
            type="recipe"
            onClick={() => {
              this.props.data.onChange(id);
              this.context.dialogClose(this.props.dialogId);
            }}
          />
        </div>))}
      </div>
    </form>);
  }

  render() {
    return (<div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
      <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
        <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
        <div className={styleDialog.content}>
          {this.renderContent()}
        </div>
      </div>
    </div>);
  }
}

const mapStateToProps = state => {
  return {
    items: state.getIn(['recipe', 'items']).toJS(),
  };
};

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/RecipePick/index.js